import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
  getZipCode,
} from "use-places-autocomplete";
import * as Popover from "@radix-ui/react-popover";
import classes from "./PlacesInput.module.css";
import { useEffect, useState } from "react";
import { Command } from "cmdk";
import { Label } from "../Label";
import { cn, RenderToast } from "@/helper/HelperFunction";

export default function PlacesInput({
  setCoordinates,
  setAddress,
  address,
  label,
  placeholder = "Search address",
  setPlaceDetail,
  leftIcon,
  error,
  errorText,
  filterStateName,
}) {
  const [open, setOpen] = useState(false);
  const {
    ready,
    value,
    setValue,
    suggestions: { status, data },
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      componentRestrictions: {
        country: "us",
      },
    },
  });

  const handleSelect = async (val) => {
    let country = "";
    let city = "";
    let state = "";
    const results = await getGeocode({ address: val });
    let addrComp = results[0].address_components;
    for (let i = 0; i < addrComp.length; ++i) {
      if (addrComp[i].types.includes("administrative_area_level_1"))
        state = addrComp[i].long_name;
      else if (addrComp[i].types.includes("locality"))
        city = addrComp[i].long_name;
      else if (addrComp[i].types.includes("country"))
        country = addrComp[i].long_name;
      //we can break early if we find all three data
      if (state !== "" && city !== "" && country !== "") break;
    }
    if (
      filterStateName &&
      state?.toLowerCase() !== filterStateName?.toLowerCase()
    ) {
      RenderToast({
        type: "error",
        message: "Please select a location in the correct state",
      });
      return false;
    }
    setValue(val, false);
    clearSuggestions();
    const zipcode = await getZipCode(results[0], false);
    const { lat, lng } = await getLatLng(results[0]);

    setPlaceDetail && setPlaceDetail({ state, city, country, zipcode });
    setCoordinates && setCoordinates({ lat, lng });
    setAddress(val);
    return true;
  };
  useEffect(() => {
    setValue(address, false);
    clearSuggestions();
  }, [address]);

  return (
    <Popover.Root open={open} modal={false} onOpenChange={setOpen}>
      <div>
        {label && <Label>{label}</Label>}
        <Popover.Trigger
          className={cn(classes.popoverTrigger, error && classes.errorTrigger)}
        >
          <span
            onClick={() => setOpen(!open)}
            style={{
              color: value ? "var(--text-color)" : "var(--placeholder-color)",
              opacity: value ? 1 : 0.4,
            }}
          >
            {value || placeholder}
            {leftIcon && <span>{leftIcon}</span>}
          </span>
        </Popover.Trigger>
        {error && <p className={classes.error}>{errorText}</p>}
      </div>
      <Popover.Content className={classes.popoverContent}>
        <Command className={classes.cmdkDialog}>
          <Command.Input
            placeholder="Search for a place..."
            className={classes.cmdkInput}
            onValueChange={(value) => {
              setValue(value);
              if (value == "") {
                setPlaceDetail && setPlaceDetail(null);
                setCoordinates && setCoordinates(null);
                setAddress && setAddress("");
                setValue("", false);
                clearSuggestions();
              }
            }}
            value={value}
          />
          <Command.List>
            {!ready && <Command.Loading>Hang on…</Command.Loading>}
            <Command.Empty className={classes.cmdkItem}>
              No results found.
            </Command.Empty>
            {status === "OK" &&
              data.length > 0 &&
              data.map(({ place_id, description }) => (
                <Command.Item
                  className={classes.cmdkItem}
                  key={place_id}
                  onSelect={async () => {
                    const isSuccess = await handleSelect(description);
                    if (!isSuccess) {
                      return;
                    }
                    setOpen(false); // Close after selection
                  }}
                >
                  {description}
                </Command.Item>
              ))}
          </Command.List>
        </Command>
      </Popover.Content>
    </Popover.Root>
  );
}
